interface Size {
  xs: string;
  sm: string;
  bsm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

export const size: Size = {
  xs: '400px', // for small screen mobile
  sm: '600px', // for mobile screen
  bsm: '750px', // between small and medium
  md: '900px', // for tablets
  lg: '1280px', // for laptops
  xl: '1440px', // for desktop / monitors
  xxl: '1920px', // for big screens
};

export const device = {
  xs: `(max-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  bsm: `(max-width: ${size.bsm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`,
};
export const sizeHeight: Partial<Size> = {
  xs: '400px', // for small screen mobile
  sm: '700px',
  md: '1000px', // for laptops
};
export const deviceHeight = {
  xs: `(max-height: ${sizeHeight.xs})`,
  sm: `(max-height: ${sizeHeight.sm})`,
  bsm: `(max-height: ${sizeHeight.bsm})`,
  md: `(max-height: ${sizeHeight.md})`,
};

// Example for using media queries
// const BlogCardsContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//
//   @media ${device.sm} {
//     flex-direction: column;
//   }
// `
